import { render } from "./user-calendar.vue?vue&type=template&id=7f1265d6&ts=true"
import script from "./user-calendar.vue?vue&type=script&lang=ts"
export * from "./user-calendar.vue?vue&type=script&lang=ts"

import "./user-calendar.vue?vue&type=style&index=0&id=7f1265d6&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__